import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DataService } from 'src/app/core/data.service';
import { MaintenanceBeforeHour, MaintenanceBeforeMinute, MaintenanceBeforeSecond } from '../models/maintenance.model';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { WarningMessageEnum } from '../general/warning-message.enum';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {
  //maintenance Data
  public scheduledMaintenanceDateTime: any;
  maintenanceWarningPopupSubject = new BehaviorSubject<string>('');
  maintenanceBeforeHourList: MaintenanceBeforeHour[] = [];
  maintenanceBeforeMinuteList: MaintenanceBeforeMinute[] = [];
  maintenanceBeforeSecondList: MaintenanceBeforeSecond[] = [];
  

  constructor(private dataService: DataService) { }

  // To get maintenance Data from Sever
  public getMaintenanceDetail(portalTypeId: number, isExistingUser: boolean, userId?: any): Observable<any> {
    return this.dataService.getRequest(
      'general/maintenance?portalTypeId=' + portalTypeId + '&isExistingUser=' + isExistingUser + '&userId=' + userId
    );
  }

  //A method to get scheduledMaintenanceDateTime value
  getScheduledMaintenanceDateTime() {
    return this.scheduledMaintenanceDateTime;
  }

  //A method to set scheduledMaintenanceDateTime value
  setScheduledMaintenanceDateTime(value: any) {
    this.scheduledMaintenanceDateTime = value; 
  }

  //A method to set maintenanceWarningPopupSubject
  setMaintenanceWarningPopupSubject(data: string) {
    this.maintenanceWarningPopupSubject.next(data);
  }

  //A method to get maintenanceWarningPopupSubject
  getMaintenanceWarningPopupSubject() {
    return this.maintenanceWarningPopupSubject.asObservable();
  }

  //A method to reset maintenanceWarningPopupSubject
  resetMaintenanceWarningPopupSubject() {
    this.maintenanceWarningPopupSubject = new BehaviorSubject<string>('');
  }

  //A method to get maintenanceBeforeHourList
  getMaintenanceBeforeHourList() {
    return this.maintenanceBeforeHourList;
  }
  //A method to set maintenanceBeforeHourList
  setMaintenanceBeforeHourList(data: any[]) {
    this.maintenanceBeforeHourList = data; 
  }

  //A method to get maintenanceBeforeMinuteList
  getMaintenanceBeforeMinuteList() {
    return this.maintenanceBeforeMinuteList;
  }
  //A method to set maintenanceBeforeMinuteList
  setMaintenanceBeforeMinuteList(data: any[]) {
    this.maintenanceBeforeMinuteList = data;
  }

  //A method to get maintenanceBeforeSecondList
  getMaintenanceBeforeSecondList() {
    return this.maintenanceBeforeSecondList;
  }
  //A method to set maintenanceBeforeSecondList
  setMaintenanceBeforeSecondList(data: any[]) {
    this.maintenanceBeforeSecondList = data;
  }

  //method to calculate and remove past hour, minutes
  removePastDateTime() {
    console.log("Local", moment.utc().local().format('YYYY-MMM-DD h:mm A')); // 2023-Oct-14 1:55 AM (based on local browser timezone)
    console.log("Final local - deployment time", moment.utc(this.scheduledMaintenanceDateTime).local().format('YYYY-MMM-DD h:mm A')); //2023-Oct-15 6:00 PM (Scheduled UTC tie to local browser timezone)
    var localTimezone = moment.utc().local();
    var convertedScheduledTimeToLocal = moment.utc(this.scheduledMaintenanceDateTime).local();

    //Remove Past Hour and Minutes from actual List bsaed on local timezone
    this.removePastHours();
    this.removePastMinutes();
  }
  
  //A method to remove past timing from actual list
  removePastHours() {
    //Temp list to Remove past time from hours
    var temporaryHourList: MaintenanceBeforeHour[] = [];
    if (this.maintenanceBeforeHourList.length > 0) {
      for (let index = 0; index < this.maintenanceBeforeHourList.length; index++) {
        var subtractedHourDate = moment.utc(this.scheduledMaintenanceDateTime).local().subtract({ hours: this.maintenanceBeforeHourList[index].hour }).local();
    
        //validate subtrcted hour datetime is future to current local datetime adn remove the index from hour list
        if (!(subtractedHourDate.isAfter(moment.utc().local()))) {
          temporaryHourList.push(this.maintenanceBeforeHourList[index]);
        }
      }
      //Remove past date time actual list
      temporaryHourList.forEach((element) => {
        this.maintenanceBeforeHourList = this.maintenanceBeforeHourList.filter((data => data.hour != element.hour));
      });

      console.log("Removed Before Hour List- ", this.maintenanceBeforeHourList);
    }
  }

  //A method to remove past timing from actual list
  removePastMinutes() {
    //To validate and remove Minute list
    var temporaryBeforeMinuteList: MaintenanceBeforeMinute[] = [];
    if (this.maintenanceBeforeMinuteList.length > 0) {
      for (let index = 0; index < this.maintenanceBeforeMinuteList.length; index++) {
        var subtractedMinuteDateTime = moment.utc(this.scheduledMaintenanceDateTime).local().subtract({ minutes: this.maintenanceBeforeMinuteList[index].minute }).local();

        //validate subtrcted minute datetime is future to current local datetime and remove the index from minute list
        if (!(subtractedMinuteDateTime.isAfter(moment.utc().local()))) {
          temporaryBeforeMinuteList.push(this.maintenanceBeforeMinuteList[index]);
        }
      }

      //Remove past date time actual list
      temporaryBeforeMinuteList.forEach((element) => {
        this.maintenanceBeforeMinuteList = this.maintenanceBeforeMinuteList.filter((data => data.minute != element.minute));
      });

      console.log("Removed Before Minute List-", this.maintenanceBeforeMinuteList);
    }
  }

  //A method to remove past timing from actual list
  removePastSeconds() {
    //To validate and remove Second list
    //Second list is not required as Maintenance will only be on hour and minute difference
    var temporaryBeforeSecondList:MaintenanceBeforeSecond[]=[];
    if(this.maintenanceBeforeSecondList.length > 0){
      for(let index=0; index<this.maintenanceBeforeSecondList.length; index++){
        var subtractedSecondDateTime = moment.utc(this.scheduledMaintenanceDateTime).local().subtract({ minutes: this.maintenanceBeforeSecondList[index].second}).local();

        //validate subtrcted minute datetime is future to current local datetime and remove the index from minute list
        if(!(subtractedSecondDateTime.isAfter(moment.utc().local()))){
          temporaryBeforeSecondList.push(this.maintenanceBeforeSecondList[index]);
        }
      }

       //Remove past date time actual list
       temporaryBeforeSecondList.forEach((element)=>{
        this.maintenanceBeforeSecondList = this.maintenanceBeforeSecondList.filter((data => data.second!=element.second));
      });

      console.log("Removed Before Second List-", this.maintenanceBeforeSecondList);
    }
  }
}
